import * as React from "react"
import { OnboardingSiteType } from "@modules/onboarding/shared/types"
import LoadingFromExternalWindow from "@modules/ui/components/LoadingFromExternalWindow"
import { CmsVendor } from "@modules/graphql/types"

type AuthorizingWindowProps = {
  formattedName: string
  onAuthorizing: () => true | undefined
  cmsVendor: CmsVendor
  siteId: string
  siteType: OnboardingSiteType
}

export function AuthorizingWindow({
  formattedName,
  onAuthorizing,
  cmsVendor,
  siteId,
  siteType,
}: AuthorizingWindowProps) {
  return (
    <div data-cy="authorizing-window">
      <LoadingFromExternalWindow
        style={{ minHeight: `calc(100vh - 15rem)` }}
        message={`We just opened a new browser window to authenticate with ${formattedName}. Accidentally closed the window?`}
        onClick={() => {
          if (onAuthorizing()) {
            return null // early return for dev & test purpose
          }

          const oauthUrl = `${
            process.env.GATSBY_DASHBOARD_AUTHENTICATION_URL
          }/oauth/${cmsVendor.toLowerCase()}?siteId=${siteId}${
            [
              OnboardingSiteType.Provision,
              OnboardingSiteType.DeployNowProvision,
            ].includes(siteType)
              ? `&provision=true`
              : ``
          }`

          window.open(
            oauthUrl,
            `_blank`,
            process.env.NODE_ENV === `production` ? `height=600,width=700` : ``
          )
        }}
      />
    </div>
  )
}
